var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { attachIndexXHover, attachIndexYHover } from '../core/interaction';
import { registerDashboard } from '../../registryCore';
import { createWidgetGroup, num, setState } from '../../helpers';
import { getActiveDashboard } from '../../theme';
import { defaultLayout, dataBounds, computeTicks, addAxes, addGridLines } from '../../chartPrimitives';
import { linearScale } from '../core/scales';
import { SAMPLE_OHLC, toHeikinAshi, toKagi, toPointAndFigure, toRenko, volumeProfile, } from '../core/financial';
function ohlcLabel(b) {
    return "C:".concat(b.close, " H:").concat(b.high, " L:").concat(b.low);
}
function attachOhlcHover(app, group, props, layout, bars) {
    attachIndexXHover(app, group, props, layout, bars.length, function (i) { return ohlcLabel(bars[i]); }, undefined, function (i) { return ({
        index: i,
        bar: bars[i],
        value: bars[i].close,
    }); });
}
function getOhlc(props) {
    var _a;
    return (_a = props.data) !== null && _a !== void 0 ? _a : SAMPLE_OHLC;
}
function plotFinancial(app, group, bars, width, height, props, style) {
    if (style === void 0) { style = 'candle'; }
    var lows = bars.map(function (b) { return b.low; });
    var highs = bars.map(function (b) { return b.high; });
    var bounds = { min: Math.min.apply(Math, __spreadArray([], __read(lows), false)), max: Math.max.apply(Math, __spreadArray([], __read(highs), false)) };
    var layout = defaultLayout(width, height);
    var yTicks = computeTicks(bounds.min, bounds.max, 5);
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    group.add(app.rect({ x: layout.plotX, y: layout.plotY, width: layout.plotWidth, height: layout.plotHeight, fill: getActiveDashboard().chartPlot, listening: false }));
    addGridLines(app, group, layout, yTicks, bounds);
    addAxes(app, group, layout, bounds, yTicks);
    var slot = layout.plotWidth / Math.max(bars.length, 1);
    var yScale = linearScale([bounds.min, bounds.max], [layout.plotY + layout.plotHeight, layout.plotY]);
    bars.forEach(function (b, i) {
        var cx = layout.plotX + slot * i + slot / 2;
        var yH = yScale(b.high);
        var yL = yScale(b.low);
        var up = b.close >= b.open;
        var color = up ? getActiveDashboard().financialUp : getActiveDashboard().financialDown;
        if (style === 'ohlc') {
            group.add(app.line({ x: cx, y: yH, x2: 0, y2: yL - yH, stroke: color, strokeWidth: 1, listening: false }), app.line({ x: cx - slot * 0.3, y: yScale(b.open), x2: slot * 0.3, y2: 0, stroke: color, strokeWidth: 2, listening: false }), app.line({ x: cx, y: yScale(b.close), x2: slot * 0.3, y2: 0, stroke: color, strokeWidth: 2, listening: false }));
        }
        else if (style === 'hilo') {
            group.add(app.line({ x: cx, y: yH, x2: 0, y2: yL - yH, stroke: color, strokeWidth: 2, listening: false }));
        }
        else {
            var yO = yScale(b.open);
            var yC = yScale(b.close);
            var bodyTop = Math.min(yO, yC);
            var bodyH = Math.max(2, Math.abs(yC - yO));
            group.add(app.line({ x: cx, y: yH, x2: 0, y2: yL - yH, stroke: color, strokeWidth: 1, listening: false }), app.rect({ x: cx - slot * 0.25, y: bodyTop, width: slot * 0.5, height: bodyH, fill: up ? color : getActiveDashboard().chartBg, stroke: color, strokeWidth: 1, listening: false }));
        }
    });
    attachOhlcHover(app, group, props, layout, bars);
    return layout;
}
function registerOhlcChart(type, style, transform) {
    registerDashboard(type, function (props, app) {
        var width = num(props, 'width', 300);
        var height = num(props, 'height', 150);
        var bars = getOhlc(props);
        var group = createWidgetGroup(app, type, props);
        if (transform)
            bars = transform(bars);
        plotFinancial(app, group, bars, width, height, props, style);
        setState(group, { width: width, height: height, data: bars });
        return group;
    });
}
registerOhlcChart('candlestickChart', 'candle');
registerOhlcChart('kLineChart', 'candle');
registerOhlcChart('ohlcChart', 'ohlc');
registerOhlcChart('highLowChart', 'hilo');
registerOhlcChart('heikinAshiChart', 'candle', toHeikinAshi);
registerOhlcChart('renkoChart', 'candle', function (b) { return toRenko(b, 3); });
registerOhlcChart('pointAndFigureChart', 'candle', function (b) { return toPointAndFigure(b, 2); });
registerDashboard('kagiChart', function (props, app) {
    var width = num(props, 'width', 300);
    var height = num(props, 'height', 150);
    var bars = getOhlc(props);
    var pts = toKagi(bars, num(props, 'reversal', 4));
    var group = createWidgetGroup(app, 'kagiChart', props);
    var layout = defaultLayout(width, height);
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    var ys = pts.map(function (p) { return p.y; });
    var bounds = dataBounds(ys);
    var yScale = linearScale([bounds.min, bounds.max], [layout.plotY + layout.plotHeight, layout.plotY]);
    var linePts = [];
    pts.forEach(function (p, i) {
        linePts.push(layout.plotX + (layout.plotWidth * i) / Math.max(pts.length - 1, 1), yScale(p.y));
    });
    group.add(app.polyline({ points: linePts, fill: null, stroke: getActiveDashboard().chartLine, strokeWidth: 2, listening: false }));
    attachIndexXHover(app, group, props, layout, pts.length, function (i) { return "price: ".concat(pts[i].y.toFixed(2)); });
    setState(group, { width: width, height: height, data: bars });
    return group;
});
registerDashboard('volumeChart', function (props, app) {
    var width = num(props, 'width', 300);
    var height = num(props, 'height', 120);
    var bars = getOhlc(props);
    var group = createWidgetGroup(app, 'volumeChart', props);
    var layout = defaultLayout(width, height);
    var maxVol = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(bars.map(function (b) { var _a; return (_a = b.volume) !== null && _a !== void 0 ? _a : 0; })), false), [1], false));
    var slot = layout.plotWidth / bars.length;
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    bars.forEach(function (b, i) {
        var _a;
        var v = (_a = b.volume) !== null && _a !== void 0 ? _a : 0;
        var h = (v / maxVol) * layout.plotHeight;
        var up = b.close >= b.open;
        group.add(app.rect({
            x: layout.plotX + i * slot,
            y: layout.plotY + layout.plotHeight - h,
            width: slot - 2,
            height: h,
            fill: up ? getActiveDashboard().financialUp : getActiveDashboard().financialDown,
            listening: false,
        }));
    });
    attachIndexXHover(app, group, props, layout, bars.length, function (i) { var _a; return "vol: ".concat((_a = bars[i].volume) !== null && _a !== void 0 ? _a : 0); });
    setState(group, { width: width, height: height, data: bars });
    return group;
});
registerDashboard('candlestickVolumeChart', function (props, app) {
    var width = num(props, 'width', 300);
    var height = num(props, 'height', 220);
    var bars = getOhlc(props);
    var group = createWidgetGroup(app, 'candlestickVolumeChart', props);
    plotFinancial(app, group, bars, width, height * 0.65, props, 'candle');
    var volH = height * 0.3;
    var layout = defaultLayout(width, volH);
    layout.plotY = height * 0.68;
    var maxVol = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(bars.map(function (b) { var _a; return (_a = b.volume) !== null && _a !== void 0 ? _a : 0; })), false), [1], false));
    var slot = layout.plotWidth / bars.length;
    bars.forEach(function (b, i) {
        var _a;
        var v = (_a = b.volume) !== null && _a !== void 0 ? _a : 0;
        var h = (v / maxVol) * layout.plotHeight;
        group.add(app.rect({
            x: layout.plotX + i * slot,
            y: layout.plotY + layout.plotHeight - h,
            width: slot - 2,
            height: h,
            fill: getActiveDashboard().inactiveBar,
            listening: false,
        }));
    });
    attachIndexXHover(app, group, props, layout, bars.length, function (i) { var _a; return "vol: ".concat((_a = bars[i].volume) !== null && _a !== void 0 ? _a : 0); });
    setState(group, { width: width, height: height, data: bars });
    return group;
});
registerDashboard('volumeProfileChart', function (props, app) {
    var width = num(props, 'width', 300);
    var height = num(props, 'height', 150);
    var bars = getOhlc(props);
    var profile = volumeProfile(bars, num(props, 'bins', 12));
    var group = createWidgetGroup(app, 'volumeProfileChart', props);
    var layout = defaultLayout(width, height);
    var maxV = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(profile.map(function (p) { return p.volume; })), false), [1], false));
    var minP = Math.min.apply(Math, __spreadArray([], __read(profile.map(function (p) { return p.price; })), false));
    var maxP = Math.max.apply(Math, __spreadArray([], __read(profile.map(function (p) { return p.price; })), false));
    group.add(app.rect({ width: width, height: height, fill: getActiveDashboard().chartBg, listening: true }));
    profile.forEach(function (p) {
        var y = layout.plotY + layout.plotHeight - ((p.price - minP) / (maxP - minP || 1)) * layout.plotHeight;
        var w = (p.volume / maxV) * layout.plotWidth * 0.4;
        group.add(app.rect({ x: layout.plotX, y: y - 4, width: w, height: 8, fill: getActiveDashboard().primary, listening: false }));
    });
    attachIndexYHover(app, group, props, layout, profile.length, function (i) { return "price ".concat(profile[i].price.toFixed(1), " vol ").concat(profile[i].volume); });
    setState(group, { width: width, height: height, data: bars });
    return group;
});
